// extracted by mini-css-extract-plugin
export default {"title":"app-timer_title__Z25td"};